import { VStack, Box, Heading, Container, Body } from '@hover/blueprint';
import React from 'react';
import { OUR_TOOLS } from '../../../constants';
import { ICareersOurTool } from '../../../interfaces/ICareersOurTool';

const Mobile: React.FC = () => (
  <VStack display={{ base: 'flex', desktop: 'none' }} spacing={600} mb={900}>
    {OUR_TOOLS.map((tool: ICareersOurTool) => (
      <Box flexDir="column" alignItems="flex-start" key={tool.id}>
        {tool.image}
        <Box
          flexDir="column"
          alignItems="flex-start"
          justifyContent="center"
          mt={500}
        >
          <Heading
            marginBottom={500}
            size={{ base: 500, tablet: 600 }}
            isLight
            as="h2"
          >
            {tool.title}
          </Heading>
          <Container px={200}>
            <Body size={500} marginBottom={500}>
              {tool.body}
            </Body>
          </Container>
        </Box>
      </Box>
    ))}
  </VStack>
);

export default Mobile;
